import { render } from "./ProjectBoard.vue?vue&type=template&id=52d00a16&scoped=true"
import script from "./ProjectBoard.vue?vue&type=script&lang=js"
export * from "./ProjectBoard.vue?vue&type=script&lang=js"

import "./ProjectBoard.vue?vue&type=style&index=0&id=52d00a16&lang=sass&scoped=true"

import exportComponent from "C:\\yb\\work\\website\\yunyu2021\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d00a16"]])

export default __exports__
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInnerLoading});
